import { useEffect, useState } from 'react';
import './AboutModal.scss';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutModal: React.FC<AboutModalProps> = ({ isOpen, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsAnimating(false);
      requestAnimationFrame(() => {
        setIsAnimating(true);
      });
    }
  }, [isOpen]);

  if (!isOpen && !isAnimating) return null;

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(onClose, 500);
  };

  return (
    <div className={`about-modal ${isAnimating ? 'visible' : 'hidden'}`} onClick={handleClose}>
      <button className="close-button" onClick={handleClose}>×</button>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <p>
          <strong>The Museum of Digital Influence</strong> is a non-commercial platform created by <a href="https://zorka.agency/" target="_blank" rel="noopener noreferrer"><strong>Zorka.Agency</strong></a>, one of the leading influencer and performance marketing agencies globally.
        </p>
        <p>
          This interactive museum takes you through 9 unique epochs, highlighting the evolution of digital influence, from the early days of blogging to the rise of platforms like TikTok. With over 100 artefacts, the Museum showcases the milestones, innovations, and trends that have shaped the way we connect and influence online.
        </p>
        <p>
          Each artefact is powered by AI, while the accompanying information and narratives are crafted by humans to ensure accuracy and relevance. The Museum's epochs are brought to life by influential ambassadors – industry leaders and influencers who have contributed to the growth of the influencer marketing landscape.
        </p>
        <p>
          Embark on this journey through the history of digital influence and support the Museum by sharing it on your social media!
        </p>
      </div>
    </div>
  );
};

export default AboutModal; 